import { lazy } from "react";
import { PATHS } from "@/lib/router";

const ManageUserPage = lazy(() => import("./pages/ManageUserPage"));
const RolesPermissionsPage = lazy(() => import("./pages/RolesPermissionsPage"));
const UserListPage = lazy(() => import("./pages/UserListPage"));

export const userManagementRoutes = [
  {
    path: PATHS.USER_LIST,
    element: <UserListPage />,
    handle: { permission: { resource: "user_list", action: "view" } },
  },
  {
    path: `${PATHS.MANAGE_USER}/:userId`,
    element: <ManageUserPage />,
    handle: {
      permission: {
        required: ["user_list:update", "user_list:edit"],
        mode: "any",
      },
    },
  },
  {
    path: PATHS.ROLES_PERMISSIONS,
    element: <RolesPermissionsPage />,
    handle: { permission: { resource: "roles_permissions", action: "view" } },
  },
];
